module.exports = __webpack_public_path__ + "static/media/confirm-popup.76738bee.svg";